import React, { Component } from 'react';
import { Mutation } from 'react-apollo';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client';
import { ApolloClient } from "apollo-client";
import { ApolloProvider } from "react-apollo";
import { gql } from 'apollo-boost';
import { createApolloFetch } from 'apollo-fetch';

//styles and icons
import { Row, Col } from 'react-bootstrap';
import img from '../../../images/image-place.png';
import Loader from 'react-loader-spinner';
import TitleIcon from '@material-ui/icons/Title';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import CropOriginalIcon from '@material-ui/icons/CropOriginal';
import PhotoLibraryOutlinedIcon from '@material-ui/icons/PhotoLibraryOutlined';
import SaveAltOutlinedIcon from '@material-ui/icons/SaveAltOutlined';


// this component represents the sidebar of video addons component

export default class AddonSidebar extends Component {
    constructor() {
        super()
        this.state = {
            textAddonsInputs: [],
            imgAddonsInputs: [],
            allAddons: []
        }
    }
    // **** function to order any array of object ***
    compareValues = (key, order = 'asc') => {
        return function innerSort(a, b) {
            if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                // property doesn't exist on either object
                return 0;
            }

            const varA = (typeof a[key] === 'string')
                ? a[key].toUpperCase() : a[key];
            const varB = (typeof b[key] === 'string')
                ? b[key].toUpperCase() : b[key];

            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            } else if (varA < varB) {
                comparison = -1;
            }
            return (
                (order === 'desc') ? (comparison * -1) : comparison
            );
        };
    }
    // *** how to use  compareValues function ***
    // array is sorted by name, in ascending order by default
    //singers.sort(compareValues('name'));

    // array is sorted by id in descending order
    //singers.sort(compareValues('id', 'desc'));

    // ****************************************************
    componentWillReceiveProps(props) {
        if (props !== this.props) {
            let tempAllAdons = [], tempImgAddon = [], tempTextAddon = [], question;
            // when push new one 
            props.textAddons.forEach(element => {
                tempTextAddon.push(element);
                tempAllAdons.push(element);
            });
            props.imgAddons.forEach(element => {
                tempImgAddon.push(element)
                tempAllAdons.push(element)
            });
            // sort the array of addons
            // tempAllAdons.sort(this.compareValues('start_time'));
            this.setState({ ...this.state, allAddons: tempAllAdons, textAddonsInputs: tempTextAddon, imgAddonsInputs: tempImgAddon, question: props.question })
            // disable save all btn when no data 
            // this.checkData(tempAllAdons);

        }
    }
    getAddonsById = () => {
        let that = this;

        const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
        const uri = 'https://spreago.black-squares.com/graphql';
        const apolloFetch = createApolloFetch({ uri });
        apolloFetch.use(({ request, options }, next) => {
            if (!options.headers) {
                options.headers = {};  // Create the headers object if needed.
            }
            options.headers['authorization'] = `Bearer ${token}`;
            next();
        });

        // get user completed visume 
        apolloFetch({
            query:
                `query{
          biosCompletedYours(first: 10000){
            data{
                id
                title
                brif
                speciality{name_en}
                tags
                bioTagsNames
                privacy{
                    id
                    name_en}
                speciality{
                    id
                    name_en
                }
                video{
                    id
                    frame{
                      url
                    }
                    url
                  }
                questions{
                id
                title
                maximum_time
                video{
                        url
                        duration
                        created_at
                        url
                        frame{
                            url
                        }
                    }
                 
              }
            }
          }
        }
        `,
        }).then(res => {
            if (res.data.biosCompletedYours) {
                that.setState({ ...that.state, biographies: res.data.biosCompletedYours.data });
            }
        });
    }
    handelDelete = (object) => {
        // send  object to delete from parent 
        this.props.callbackFromParent(object, "delete");
    }
    handleView = (object) => {
        // send  object to edit from parent
        this.props.callbackFromParent(object, "view");
    }
    resetSidebar = () => {
        // reset all data 
        this.props.callbackFromParent(this.state.allAddons, "reset all");
    }
    checkData = (tempAllAdons) => {
        if (tempAllAdons.length > 0) {
            document.querySelector('#saveAllAddons').disabled = false;
        }
        else {
            document.querySelector('#saveAllAddons').disabled = true;
        }
    }
    handleOnClick = () => {
        let recordCards = document.querySelectorAll('.record-card');
        let btnNextRecord = document.querySelector('.record-next-btn');
        let btnBackRecord = document.querySelector('.record-back-btn');

        // save changes when user clicks on another video 
        // recordCards.forEach(recordCard => {
        //     recordCard.addEventListener("click", () => {
        //         if (this.state.allAddons) {
        //             document.querySelector("#saveAllAddons").click();
        //         }
        //     })
        // })
        // save changes when user clicks next 
        if (btnNextRecord) {
            btnNextRecord.addEventListener("click", () => {
                if (this.state.allAddons) {
                    document.querySelector("#saveAllAddons").click();
                }
            })
        }
        // save changes when user clicks back
        if (btnBackRecord) {
            btnBackRecord.addEventListener("click", () => {
                if (this.state.allAddons) {
                    document.querySelector("#saveAllAddons").click();
                }
            })
        }
    }
    componentDidMount() {
        this.handleOnClick();
    }
    sortUnorderedList = (ul, sortDescending) => {
        if (typeof ul == "string")
            ul = document.querySelector(ul);

        // Idiot-proof, remove if you want
        if (!ul) {
            return;
        }

        // Get the list items and setup an array for sorting
        var lis = ul.getElementsByTagName("LI");
        var vals = [];

        // Populate the array
        for (var i = 0, l = lis.length; i < l; i++)
            vals.push(lis[i].innerHTML);

        // Sort it
        vals.sort();

        // Sometimes you gotta DESC
        if (sortDescending)
            vals.reverse();

        // Change the list on the page
        for (var i = 0, l = lis.length; i < l; i++)
            lis[i].innerHTML = vals[i];
    }
    render() {
        // this.sortUnorderedList('.sidebar-ul');
        // activate uploading link on the oppollo 
        const apolloCache = new InMemoryCache({
            addTypename: false
        })
        const token = (localStorage.getItem('jwt')) ? JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token : '';

        const uploadLink = createUploadLink({
            uri: 'https://spreago.black-squares.com/graphql',
            headers: {
                authorization: token ? `Bearer ${token}` : ""
            }
        })
        const client = new ApolloClient({
            cache: apolloCache,
            link: uploadLink
        })
        return (
            <ApolloProvider client={client}>
                <Row className="m-0">
                    <Col md={12} xs={6} className="bg-darkblue p-1 order-1">
                        {(this.state.question) ?
                            <Row className="m-0 justify-content-center align-items-center p-1">
                                <Col xs={2} className="p-0 text-center">
                                    <img src={(this.state.question.video) ? this.state.question.video.frame.url : img} className="" alt="" width="17px" />
                                </Col>
                                <Col xs={10} className="p-0 text-white pl-1">
                                    <p className="mb-0 captialize">{this.state.question.title.substring(0, 10)}..</p>
                                </Col>
                            </Row>
                            : ''}
                    </Col>
                    <Col className="p-0 order-3"
                        xs={12}
                        style={{ maxHeight: '100vh', overflow: 'auto', minHeight: '2rem' }}>
                        <ul className="list-style-none pl-0 addons-list pb-0 sidebar-ul">
                            {this.state.allAddons.map(item =>
                                <li className="p-1 row m-0 border-bottom sidebar-li">
                                    <Col xs={8} className="p-0 text-center">
                                        <button
                                            onClick={() => this.handleView(item)}
                                            className="border-0 bg-transparent p-0 w-100 p-relative"
                                        >
                                            <div className="mb-0">
                                                {(item.text) ?
                                                    <div className="row m-0 justify-content-center align-items-center">
                                                        <Col className="p-0 text-left">
                                                            <p className="mb-0">{(item.start_time < 10) ? '0' + item.start_time + ':00' : item.start_time + ':00'}</p>
                                                        </Col>
                                                        <Col className="p-0 text-center">
                                                            <TitleIcon style={{ width: '25px' }} />
                                                        </Col>
                                                    </div>
                                                    :
                                                    <div className="row m-0 justify-content-center align-items-center">
                                                        <Col className="p-0 text-left">
                                                            <p className="mb-0">{(item[0].start_time < 10) ? '0' + item[0].start_time + ':00' : item[0].start_time + ':00'}</p>
                                                        </Col>
                                                        <Col className="p-0 text-center images-list">
                                                            {(item.length > 1) ?
                                                                <PhotoLibraryOutlinedIcon style={{ width: '25px' }} /> : <CropOriginalIcon style={{ width: '25px' }} />}
                                                        </Col>
                                                    </div>
                                                }
                                            </div>
                                        </button>
                                    </Col>
                                    <Col xs={4} className="p-0 text-right">
                                        <button
                                            onClick={() => this.handelDelete(item)}
                                            className="mb-0 border-0 bg-transparent">
                                            <DeleteSweepIcon style={{ fontSize: '1rem' }} />
                                        </button>
                                    </Col>
                                </li>
                            )}
                        </ul>
                    </Col>
                    <Col md={12} xs={6}
                        className="bg-darkblue order-2 p-1 text-center pt-2 pb-2 p-absolute sidebar-bottom-responsive"
                        style={{ bottom: '5px' }}>
                        <Mutation mutation={UPLOAD_ADDONS}>
                            {(addonsUpload, { data, loading }) =>
                                <div>
                                    <button
                                        id="saveAllAddons"
                                        className="text-white mb-0 bg-transparent border-0"
                                        onClick={() => {
                                            let handleImgAddons = []
                                            this.state.imgAddonsInputs.forEach(imgAddonArr => {
                                                imgAddonArr.forEach(imgAddon => {
                                                    if (imgAddon.id) {
                                                        delete imgAddon.file
                                                        delete imgAddon.url
                                                    }
                                                    handleImgAddons.push(imgAddon)
                                                })
                                            })
                                            let handleTextAddons = this.state.textAddonsInputs;
                                            let question_id = this.state.question?.id
                                           if(question_id){
                                                addonsUpload({
                                                    variables: {
                                                        question_id: question_id,
                                                        textAddonsInputs: handleTextAddons,
                                                        imageAddonsInputs: handleImgAddons
                                                    }
                                                }).then((res, loading) => {
                                                    if (res.data.addonsUpload.Status.code === 200) {
                                                        this.resetSidebar()
                                                        //  console.log(res.data.addonsUpload)
                                                    }
                                                }).catch((err) => console.log(err));
                                            }
                                        }}
                                    >
                                        Save All <SaveAltOutlinedIcon style={{ fontSize: '1rem' }} />
                                    </button>
                                    {loading &&
                                        <div className="loading">
                                            <Loader
                                                type="TailSpin"
                                                color="white"
                                                height={50}
                                                width={50}
                                            />
                                        </div>
                                    }
                                </div>
                            }
                        </Mutation>
                    </Col>
                </Row>
            </ApolloProvider>
        )
    }
}

const UPLOAD_ADDONS = gql`
    mutation(
        $question_id       :   Int               !
        $textAddonsInputs  : [ textAddonsInputs  ]
        $imageAddonsInputs : [ imageAddonsInputs ]) {
        addonsUpload (
            Inputs : {
                question:{  id : $question_id}
                textAddonsInputs	:	$textAddonsInputs
                imageAddonsInputs	:	$imageAddonsInputs
            }
        ) {
            Status {
                code
            }
            question{
                title
                bio{
                    title
                }
                video{
                    url
                    ImageAddons{
                        id
                        start_time
                        data
                      }
                      TextAddons{
                              text
                        start_time
                        data
                      }
                }
            }
        }
    }
`


